export const months: {
  name: string;
  value: number;
}[] = [
    { name: "January", value: 0 },
    { name: "February", value: 1 },
    { name: "March", value: 2 },
    { name: "April", value: 3 },
    { name: "May", value: 4 },
    { name: "June", value: 5 },
    { name: "July", value: 6 },
    { name: "August", value: 7 },
    { name: "September", value: 8 },
    { name: "October", value: 9 },
    { name: "November", value: 10 },
    { name: "December", value: 11 },
  ];

export const PRIMARY_COLOR = "#bf2b30";
export const BUTTON_COLOR = "#eb7171";

export enum ReportId {
  DailyTimeCards = "time-card-activity",
  TimeCards = "time-card",
  TimeAnalysis = "time-analysis",
  EmployeeActivityDetail = "activity-detail",
  OverFortyHoursCheck = "over-forty-hours",
  LateEmployees = "late",
  LateNoShowEmployees = "late-no-show",
  JobSummary = "job-summary",
  JobActualVsSchedule = "actual-vs-scheduled",
  WorkforceDashboard = "workforce-dashboard",
}

export const reportsMapping: Record<ReportId, string> = {
  [ReportId.DailyTimeCards]: "Daily Time Cards",
  [ReportId.TimeCards]: "Time Cards",
  [ReportId.TimeAnalysis]: "Time Analysis",
  [ReportId.EmployeeActivityDetail]: "Employee Activity Detail",
  [ReportId.OverFortyHoursCheck]: "Over 40 Hours Check",
  [ReportId.LateEmployees]: "Late Employees",
  [ReportId.LateNoShowEmployees]: "Late & No-Show Employees",
  [ReportId.JobSummary]: "Job Summary",
  [ReportId.JobActualVsSchedule]: "Job Actual vs Schedule",
  [ReportId.WorkforceDashboard]: "Workforce Dashboard",
};

export interface AnalyticsReport {
  id: string;
  name: string;
}

export const ANALYTICS_REPORTS: readonly AnalyticsReport[] = [
  { id: "budget-report", name: "Budget Report" }, // TODO: update with actual report name
  { id: "scorecard", name: "Scorecard Report" }, // TODO: update with actual report name
  { id: "dcs-labor-cost", name: "DCS Labor Cost" },
];
